import axios from "axios";

import { SESSION_TOKEN } from "../../../constants";
import { flightOrderMock } from "../../../tests";
import mockDataPast from "../../../tests/pastMock";

const contentType = "application/json";

export const VoeBizApi = (apiDomain: string) => {
  return {
    memberFlights: async (offset: string, limit: string, flightType: string, startDate: string, endDate: string) => {
      const token = localStorage.getItem(SESSION_TOKEN);
      const vbzDebug = localStorage.getItem("vbzDebug");

      if (vbzDebug) {
        if (flightType === "FUTURE") {
          const data = flightOrderMock;
          // const data = flightOrderMock7d;
          // const data = flightOrderMock15d;
          // const data = flightOrderMock30d;
          // const data = flightOrderMockNoInterval;

          return { success: true, response: { data } };
        }
        const data = mockDataPast;
        return { success: true, response: { data } };
      }

      return axios
        .get(
          `${apiDomain}/memberflight/v1/member/flights?&limit=50&startDate=${startDate}&endDate=${endDate}&flightType=${flightType}`,
          {
            headers: {
              "Content-Type": contentType,
              Authorization: `Bearer ${token}`,
            },
          },
        )
        .then((response) => {
          return { success: true, response: { data: response.data } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },
  };
};
